<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/chilvovsky0006#loi">List of Illustrations</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0007#intro"><span class="sm">INTRODUCTION</span></a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0008#ch01"><span class="sm">ONE</span>  /  When Anyone Can Tell</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0009#ch02"><span class="sm">TWO</span>  /  Expert Witnesses on Trial</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0010#ch03"><span class="sm">THREE</span>  /  Plainclothes Decoys and the Limits of Criminal Justice</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0011#ch04"><span class="sm">FOUR</span>  /  The Rise of Ethnographic Policing</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0012#ch05"><span class="sm">FIVE</span>  /  Peepholes and Perverts</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0013#ch06"><span class="sm">SIX</span>  /  The Popular Press and the Gay World</a></p>
<p class="toc"><a class="xref" href="#/chilvovsky0014#epil"><span class="sm">EPILOGUE</span></a></p>
<p class="tocbmf"><a class="xref" href="#/chilvovsky0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chilvovsky0016#abbrs">List of Abbreviations</a></p>
<p class="tocbm"><a class="xref" href="#/chilvovsky0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chilvovsky0019#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lvovsky-0005.vue?30a39747